import { withAdalLogin, AuthenticationContext } from 'react-adal';

import { ReactAI } from 'react-appinsights';
import { adalConfig } from '../utils/adalConfig';

export class AuthStore {
    authContext: AuthenticationContext;

    constructor() {
        this.authContext = new AuthenticationContext(adalConfig);
        const userCtx = this.authContext.getCachedUser();
        /*if (userCtx !== null && ReactAI.rootInstance !== undefined) {
            //ReactAI.rootInstance.setAuthenticatedUserContext(userCtx.userName);
        }*/
    }

    get isAuthenticated(): boolean {
        return this.getCachedToken !== null;
    }

    get username() {
        if (!this.isAuthenticated) {
            return null;
        }
        return this.authContext.getCachedUser().userName;
    }

    get login() {
        return withAdalLogin(this.authContext, adalConfig.tenant!);
    }

    get getCachedToken(): string | null {
        if (sessionStorage['adal.error'] && sessionStorage['adal.error'].length > 0) {
            authStore!.refreshToken();
        }
        return this.authContext.getCachedToken(adalConfig.clientId);
    }

    refreshToken() {
        sessionStorage.clear();
        this.authContext.getCachedUser();
        this.authContext.acquireToken(adalConfig.clientId, (error, token) => {
            window.location.reload();
        });
    }

    logOut() {
        this.authContext.logOut();
    }
}

export const authStore = new AuthStore();
